import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Search = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M17 17L21 21" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M3 11C3 15.4183 6.58172 19 11 19C13.213 19 15.2161 18.1015 16.6644 16.6493C18.1077 15.2022 19 13.2053 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="outline">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { Search };